module.exports = __webpack_public_path__ + "static/media/Niveau_elN6_3_817226.e347be35.png";